'use client';

import { DraftLabel } from '~components/DraftLabel/DraftLabel';
import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { SectionMods } from '~components/Section/Section.types';
import { SectionEvent } from '~components/SectionEvent/SectionEvent';

import styles from './ArticlePage.module.scss';
import { ArticlePageProps } from './ArticlePage.types';
import { ArticlePageContent } from './ArticlePageContent/ArticlePageContent';
import { ArticlePageHero } from './ArticlePageHero/ArticlePageHero';
import { ArticlePageRecommend } from './ArticlePageRecommend/ArticlePageRecommend';

export const ArticlePage = ({
  isPublished,
  hero,
  content,
  sectionSubscribe,
  sectionEvent,
  subscribeId,
  sectionRecommend,
  tags,
}: ArticlePageProps) => {
  return (
    <>
      {!isPublished && <DraftLabel text="Вы просматриваете черновую версию" />}
      <LayoutContainer>
        <div className={styles.container}>
          <ArticlePageHero
            {...hero}
            mods={[SectionMods.SeparatorL, SectionMods.Top]}
          />
          {content && (
            <ArticlePageContent
              subscribeId={subscribeId}
              content={content}
              sectionSubscribe={sectionSubscribe}
              tags={tags}
            />
          )}
          {sectionEvent && (
            <SectionEvent {...sectionEvent} mods={[SectionMods.SeparatorL]} />
          )}
          {sectionRecommend && (
            <ArticlePageRecommend
              {...sectionRecommend}
              mods={[SectionMods.SeparatorL]}
            />
          )}
        </div>
      </LayoutContainer>
    </>
  );
};
